import ValidationLocationService from "./validationLocationService"

/**
 * Validation Location service instance
 */
const validationLocationService = new ValidationLocationService()

export default validationLocationService
